import React, { useState, useRef, useEffect } from "react"
import PropTypes from "prop-types"

const defaultState = {
    modalOpen: false,
    setModalOpen: () => { },
    externalUrl: null,
    setExternalUrl: () => { },
    modalType: null,
    setModalType: () => { },
}

const AppContext = React.createContext(defaultState)

const AppProvider = ({ children }) => {
    const [modalOpen, setModalOpen] = useState(defaultState.modalOpen);
    const [url, setUrl] = useState(defaultState.externalUrl);
    const [modalType, setModalType] = useState(defaultState.modalType);
    const headerRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = e => {
            if (e.key === 'Escape' && modalOpen) {
                setModalOpen(false);
                setUrl(null);
                setModalType(null);
            }
        };

        if(modalOpen){
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [modalOpen]);

    const store = {
        modalOpen: modalOpen,
        setModalOpen: setModalOpen,
        externalUrl: url,
        setExternalUrl: setUrl,
        modalType: modalType,
        setModalType: setModalType,
        headerRef: headerRef,
    };
    return <AppContext.Provider value={store}>{children}</AppContext.Provider>
}

AppProvider.propTypes = {
    children: PropTypes.node,
};

export default AppContext

export { AppProvider }
